import { Draft } from '@reduxjs/toolkit';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { PhotoVariableInput, ProcessedPhotoInput, UnprocessedPhotoInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { PhotoUploadData, ProcessedUploadData } from './PhotoUploadData';

export const handlePending = (
    input: Draft<GiftJson.Input<PhotoVariableInput>>,
    requestMeta: PhotoUploadData
) => {

    let value: PhotoVariableInput = toUnprocessedPhoto(input.value, requestMeta);

    if (requestMeta.processed) {
        value = toProcessedPhoto(value as UnprocessedPhotoInput, requestMeta);
    }

    input.value = value;
};

const toUnprocessedPhoto = (
    value: PhotoVariableInput,
    requestMeta: PhotoUploadData
): UnprocessedPhotoInput => ({
    ...value,
    cuid: requestMeta.cuid,
    fileName: requestMeta.fileName,

    processed: false,
    status: 'saving'
});

const toProcessedPhoto = (
    value: UnprocessedPhotoInput,
    requestMeta: ProcessedUploadData
): ProcessedPhotoInput => ({
    ...value,
    processed: true,
    assetSource: 'local',
    localUrl: requestMeta.localUrl,
    imageWidth: requestMeta.imageWidth,
    imageHeight: requestMeta.imageHeight,
    cropBox: {
        x: 0,
        y: 0,
        width: requestMeta.imageWidth,
        height: requestMeta.imageHeight
    },
    autoFaceCenter: true,
    detections: []
});